import { Injectable } from '@angular/core';
import { DelayService } from '../delay/delay.service';

@Injectable({
  providedIn: 'root'
})
export class StatesService {

  constructor() { }

  public static async getOrderStatusList(): Promise<Array<string>> {
    const list = new Array<string> ();

    list.push('CREATED');
    list.push('ACK');
    list.push('INPROGRESS');
    list.push('PENDING');
    list.push('CANCELLED');
    list.push('HELD');
    list.push('COMPLETED');
    list.push('FAILED');
    list.push('PARTIAL');
    list.push('SAVED');
    list.push('CANCELLING');
    list.push('CANCELLING_HELD');

    await DelayService.delay(2000);
    
    return list;
  }
}
